import {createReducer} from 'redux-act';
import {
  CLEAR_CASHBACK_DATA,
  GET_CASHBACK_SETTINGS_SUCCESS,
  GET_CASHBACK_SUMMARY_SUCCESS,
  SET_CASHBACK_SETTINGS_LOADING,
  SET_LOADING
} from './action';

const initialState = () => ({
  data: null,
  settings: null,
  settingsLoading: false,
  loading: false
});

const cashbackReducer = createReducer(
  {
    [GET_CASHBACK_SUMMARY_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload || null
    }),
    [GET_CASHBACK_SETTINGS_SUCCESS]: (state, payload) => ({
      ...state,
      settings: payload || null
    }),
    [SET_CASHBACK_SETTINGS_LOADING]: (state, payload) => ({
      ...state,
      settingsLoading: payload
    }),
    [SET_LOADING]: (state, payload) => ({
      ...state,
      loading: payload
    }),
    [CLEAR_CASHBACK_DATA]: () => ({
      ...initialState()
    })
  },
  initialState()
);

export default cashbackReducer;
